var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.341 16.103a.146.146 0 010-.206l5.403-5.403a.875.875 0 00-1.239-1.237l-5.402 5.4a.146.146 0 01-.207 0l-5.402-5.4a.875.875 0 10-1.238 1.237l5.402 5.403a.146.146 0 010 .206l-5.402 5.403a.875.875 0 001.238 1.238l5.402-5.404a.146.146 0 01.207 0l5.402 5.404a.875.875 0 101.238-1.238l-5.402-5.403z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgClose;